module.exports = __webpack_public_path__ + "assets/2c9976335fbb893effb5044006ff5b15.png";